module.exports = __webpack_public_path__ + "static/media/stenobothrus_lineatus.3766abc4.jpg";